(function() {
    angular
        .module("app")
        .factory("authorizationService", authorizationService)

    authorizationService.$inject = ["$rootScope", "$window"]

    function authorizationService($rootScope, $window) {
        let evaluator = null
        const STORAGE_KEY = "auth_scoped_permissions"
        const schema = require("./permissions-schema.json")

        const service = {
            initialize: initialize,
            restoreFromSession: restoreFromSession,
            clear: clear,
            can: can,
            hasScope: hasScope,
            isReady: () => evaluator !== null
        }

        return service

        function initialize(scopesHash, backendSchemaVersion) {
            if (!scopesHash) {
                console.error("[authorizationService] Cannot initialize — no scopes data")
                return false
            }

            // Schema version check (graceful — backend may not send this yet)
            if (backendSchemaVersion && backendSchemaVersion.split("-")[0] !== schema.v) {
                console.warn("[authorizationService] Schema version mismatch: backend=" +
                    backendSchemaVersion + " bundled=" + schema.v +
                    ". Permission checks may be inaccurate. Please refresh.")
            }

            evaluator = new window.PermissionEvaluator(scopesHash)

            // Persist to sessionStorage for page refresh recovery
            try {
                $window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(scopesHash))
            } catch (e) {
                console.error("[authorizationService] sessionStorage write failed:", e)
            }

            return true
        }

        function restoreFromSession() {
            try {
                const stored = $window.sessionStorage.getItem(STORAGE_KEY)
                if (!stored) return false

                const scopesHash = JSON.parse(stored)
                evaluator = new window.PermissionEvaluator(scopesHash)
                return true
            } catch (e) {
                console.error("[authorizationService] Failed to restore from session:", e)
                clear()
                return false
            }
        }

        function clear() {
            evaluator = null
            try {
                $window.sessionStorage.removeItem(STORAGE_KEY)
            } catch (e) { /* ignore */ }
        }

        function can(permission, customerId) {
            // Superroot bypass — superroot has no scoped_permissions, bypasses auth entirely
            if ($rootScope.user && $rootScope.user.role === "superroot") {
                return true
            }

            if (!evaluator) {
                // Not initialized — deny all. Old booleans still work during transition.
                return false
            }
            return evaluator.can(permission, customerId != null ? customerId : null)
        }

        function hasScope(scopeType) {
            // Superroot bypass
            if ($rootScope.user && $rootScope.user.role === "superroot") {
                return true
            }

            if (!evaluator) return false
            return evaluator.hasScope(scopeType)
        }
    }
})()
